import { render, staticRenderFns } from "./articleCard.vue?vue&type=template&id=11276b59&scoped=true&"
import script from "./articleCard.vue?vue&type=script&lang=js&"
export * from "./articleCard.vue?vue&type=script&lang=js&"
import style0 from "./articleCard.vue?vue&type=style&index=0&id=11276b59&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11276b59",
  null
  
)

export default component.exports